module.exports = __webpack_public_path__ + "img/img_yijian.9d540cc5.jpg";